import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from 'src/app/helper.service';
import { MappingComponent } from '../../mapping/mapping.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import { BoundaryManagementService } from 'src/app/services/boundary-management.service';


@Component({
    selector: 'app-add-field',
    templateUrl: './add-field.component.html',
    styleUrls: ['./add-field.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AddFieldComponent implements OnInit {

  fieldForm = new FormGroup({
    name: new FormControl('', Validators.compose([
      Validators.required,
      Validators.maxLength(30),
      // Validators.pattern('^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$'),
      // Validators.pattern(".*\\S.*[a-zA-z0-9 ]"),
      Validators.pattern(/^((?!\s{2,}).)*$/)
    ]))
  });

  public field_validation_messages;

  fieldName = "";
  farmId;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public translate: TranslateService,
  public boundaryManagementService: BoundaryManagementService,
  private _snackBar: MatSnackBar,
  private helper: HelperService,
  public dialogRef: MatDialogRef<MappingComponent>) { 

    this.field_validation_messages = {
      'name': [
        { type: 'required', message: translate.instant('ADD-FIELD-DIALOG.ERROR-NAME-REQUIRED') },
        { type: 'maxlength', message: translate.instant('ADD-FIELD-DIALOG.ERROR-NAME-LENGTH') },
        { type: 'pattern', message: translate.instant('ADD-FIELD-DIALOG.ERROR-PATTERN') }
      ]
    }

    if (data.farmId != null) {
      this.farmId = data.farmId;
    }
  }

  ngOnInit(): void {
  }

  cancel() {
    this.dialogRef.close();
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

  addField() {
    if (this.fieldName != "" && this.fieldName != null && this.fieldName != ' ') {
        this.dialogRef.close({"option": "add", "fieldName": this.fieldName});
    } else {
      this.openSnackBar(this.translate.instant("ADD-FIELD-DIALOG.INFO-NEEDED"), this.translate.instant("SNACKBAR.DISMISS"));
    }
  }
}
